<template>
    <a-modal class="modal-box" v-model="visible" :title="$t('submission.email_view.modal_title' /* 邮件内容 */)" width="900px" @cancel="visible = false" :footer="null">
        <div>
            {{ $t('submission.email_view.dear_dr' /* Dear Dr. */) }}
            <u>11111</u>
        </div>
        <table class="mt20" border="1">
            <thead>
                <tr>
                    <th class="t-l">{{ $t('submission.email_view.table1_id' /* ID */) }}</th>
                    <th class="t-l">{{ $t('submission.email_view.table1_title' /* 稿件题目 */) }}</th>
                    <th class="t-l">{{ $t('submission.email_view.table1_first_author' /* 第一作者 */) }}</th>
                    <th class="t-l">{{ $t('submission.email_view.table1_result' /* 评审结果 */) }}</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>123123</td>
                    <td>{{ $t('submission.email_view.table1_paper_title' /* 题目 */) }}</td>
                    <td>{{ $t('submission.email_view.table1_author' /* 作者 */) }}</td>
                    <td>{{ $t('submission.email_view.table1_result_value' /* 结果 */) }}</td>
                </tr>
            </tbody>
        </table>
        <div class="mt20">
            <a-row :gutter="[15, 15]">
                <a-col :span="12">
                    <span>{{ $t('submission.email_view.row_paper_number' /* 论文序号 */) }}：123123</span>
                </a-col>
                <a-col :span="12">
                    <span>{{ $t('submission.email_view.row_paper_title' /* 论文题目 */) }}：123123</span>
                </a-col>
                <a-col :span="12">
                    <span>{{ $t('submission.email_view.row_first_author' /* 第一作者 */) }}：123123</span>
                </a-col>
                <a-col :span="12">
                    <span>{{ $t('submission.email_view.row_all_authors' /* 所有作者 */) }}：123123</span>
                </a-col>
                <a-col :span="12">
                    <span>{{ $t('submission.email_view.row_review_result' /* 评审结果 */) }}：123123</span>
                </a-col>
                <a-col :span="12">
                    <span>{{ $t('submission.email_view.row_title' /* 题目 */) }}：数据分析培训数据分析培训</span>
                </a-col>
            </a-row>
        </div>

        <table class="mt20" border="1">
            <thead>
                <tr>
                    <th class="t-l">{{ $t('submission.email_view.table2_id' /* ID */) }}</th>
                    <th class="t-l">{{ $t('submission.email_view.table2_title' /* 稿件题目 */) }}</th>
                    <th class="t-l">{{ $t('submission.email_view.table2_first_author' /* 第一作者 */) }}</th>
                    <th class="t-l">{{ $t('submission.email_view.table2_corresponding_author' /* 通讯作者 */) }}</th>
                    <th class="t-l">{{ $t('submission.email_view.table2_result' /* 评审结果 */) }}</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>123123</td>
                    <td>
                        <p>{{ $t('submission.email_view.table2_paper_title' /* 题目 */) }}</p>
                    </td>
                    <td>{{ $t('submission.email_view.table2_first_author_value' /* 第一作者 */) }}</td>
                    <td>{{ $t('submission.email_view.table2_corresponding_author_value' /* 通讯作者 */) }}</td>
                    <td>{{ $t('submission.email_view.table2_result_value' /* 结果 */) }}</td>
                </tr>
            </tbody>
        </table>
    </a-modal>
</template>

<script>
export default {
    name: 'EmailView',
    components: {},
    data() {
        return {
            visible: false
        };
    },
    computed: {},
    methods: {
        show(id) {
            this.visible = true;
        },
        handleCancelEvent() {
            this.visible = false;
        }
    },
    created() {},
    mounted() {}
};
</script>
<style lang="less" scoped>
table {
    border-collapse: collapse;
    width: 100%;
    border: 1px solid #e8e8e8;
    th {
        background-color: #f7f7f7;
        border-bottom: 1px solid #e8e8e8;
        width: 150px;
        padding: 10px 15px;
        text-align: center;
    }
    td {
        border-bottom: 1px solid #e8e8e8;
        padding: 10px 15px;
        vertical-align: middle;
        color: #666;
    }
}
</style>
